import getTranslations from "../lib/getTranslations";
import SellersLandingPage from "components/SellersLandingPage/SellersLandingPage";

const Leoluxpage = () => {
  return <SellersLandingPage brand="leolux" />;
};

Leoluxpage.getLayout = page => page;

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await getTranslations(locale, ["sellers-landing"])),
    },
  };
};

export default Leoluxpage;
